import { render } from "./DL.vue?vue&type=template&id=887a4b8a"
import script from "./DL.vue?vue&type=script&lang=js"
export * from "./DL.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__